import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import employeeService from '../../../services/Employee.service';
import StencilLinkStyling from '../common/StencilLinkStyling';
import { convertHtmlBoldToStencilBold } from '../common/common';

import { Container } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';

class BrokerSatisfaction extends Component {
  render() {
    const { t, employee } = this.props;

    return (
      <Container maxWidth="776px" alignItems="center" justifyContent="center">
      { employeeService.isAPSEmployee(employee) && (employeeService.isBrokerChoiceAll(employee) || employeeService.isBrokerChoiceDisable(employee)) && employeeService.isUserCode5Email(employee) &&
        <StencilLinkStyling>
          <Text dangerouslySetInnerHTML={{ __html: convertHtmlBoldToStencilBold(t("AvailableBrokers.BrokerRatingsText")) }} fontSize="T200" fontWeight="medium" color="neutral70" textAlign="center"/>
        </StencilLinkStyling>
      }
      </Container>
    );
  }
}

const mapState = state => ({
  employee: state.employee
});

export default connect(mapState, null)(withTranslation('translationsV2')(BrokerSatisfaction));
